import axiosInstance from './api'

/**
 * Fetch tasks (one row per student). Optional limit for dashboard; no limit for Assignment tab.
 * @param {number|undefined} limit - When set (e.g. 20), only that many rows returned for dashboard preview.
 */
export const fetchTasks = async (limit) => {
	try {
		const params = limit != null && limit > 0 ? { limit } : {}
		const response = await axiosInstance.get('/counseling/tasks', { params })
		return response.data
	} catch (error) {
		console.error('Error fetching tasks:', error)
		throw error
	}
}

/**
 * Create a new task/assignment
 */
export const createTask = async (taskData) => {
	try {
		const response = await axiosInstance.post('/counseling/tasks', taskData)
		return response.data
	} catch (error) {
		console.error('Error creating task:', error)
		throw error
	}
}

/**
 * Update an existing task/assignment
 */
export const updateTask = async (taskId, taskData) => {
	try {
		const response = await axiosInstance.put(`/counseling/tasks/${taskId}`, taskData)
		return response.data
	} catch (error) {
		console.error('Error updating task:', error)
		throw error
	}
}

/**
 * Fetch classroom statistics
 */
export const fetchClassroomStats = async () => {
	try {
		const response = await axiosInstance.get('/counseling/classroom/stats')
		return response.data
	} catch (error) {
		console.error('Error fetching classroom stats:', error)
		throw error
	}
}

export const mockDashboardTasks = [
	{
		id: 1,
		task: 'Review SOP Draft 3 - Stanford',
		type: 'Essay',
		studentId: 1,
		studentName: 'Alisha K.',
		studentCountry: 'US',
		due: 'Today',
		dueDate: '2026-01-05',
		action: 'Review',
	},
	{
		id: 2,
		task: 'Review personal statement - Oxford',
		type: 'Essay',
		studentId: 2,
		studentName: 'Sara M.',
		studentCountry: 'DE',
		due: 'Tomorrow',
		dueDate: '2026-01-06',
		action: 'Review',
	},
	{
		id: 3,
		task: 'MIT application deadline',
		type: 'Application',
		studentId: 3,
		studentName: 'James P.',
		studentCountry: 'CA',
		due: 'Jan 15',
		dueDate: '2026-01-15',
		action: 'Review',
	},
	{
		id: 4,
		task: 'Verify transcript documents',
		type: 'Document',
		studentId: 4,
		studentName: 'Omar H.',
		studentCountry: 'UK',
		due: 'Jan 07',
		dueDate: '2026-01-07',
		action: 'Verify',
	},
	{
		id: 5,
		task: 'Stanford Early Action deadline',
		type: 'Application',
		studentId: 5,
		studentName: 'Emma W.',
		studentCountry: 'AU',
		due: 'Jan 28',
		dueDate: '2026-01-28',
		action: 'Review',
	},
	{
		id: 6,
		task: 'Cambridge UCAS deadline',
		type: 'Application',
		studentId: 6,
		studentName: 'David L.',
		studentCountry: 'SG',
		due: 'Jan 12',
		dueDate: '2026-01-12',
		action: 'Review',
	},
	{
		id: 7,
		task: 'Upload missing LOR',
		type: 'Document',
		studentId: 1,
		studentName: 'Alisha K.',
		studentCountry: 'US',
		due: 'Today',
		dueDate: '2026-01-05',
		action: 'Verify',
	},
	{
		id: 8,
		task: 'Common App activities section check',
		type: 'Essay',
		studentId: 7,
		studentName: 'Sophia N.',
		studentCountry: 'NL',
		due: 'Jan 10',
		dueDate: '2026-01-10',
		action: 'Review',
	},
	{
		id: 9,
		task: 'Finalize essay - UC Berkeley',
		type: 'Essay',
		studentId: 8,
		studentName: 'Liam A.',
		studentCountry: 'CA',
		due: 'Jan 20',
		dueDate: '2026-01-20',
		action: 'Review',
	},
	{
		id: 10,
		task: 'Application checklist verification',
		type: 'Document',
		studentId: 9,
		studentName: 'Noah M.',
		studentCountry: 'CH',
		due: 'Jan 09',
		dueDate: '2026-01-09',
		action: 'Verify',
	},
	{
		id: 11,
		task: 'Essay feedback round 2 - Yale',
		type: 'Essay',
		studentId: 10,
		studentName: 'Mia T.',
		studentCountry: 'US',
		due: 'This Month',
		dueDate: '2026-01-25',
		action: 'Review',
	},
	{
		id: 12,
		task: 'Confirm IELTS score report upload',
		type: 'Document',
		studentId: 11,
		studentName: 'Ivan R.',
		studentCountry: 'DE',
		due: 'Jan 18',
		dueDate: '2026-01-18',
		action: 'Verify',
	},
	{
		id: 13,
		task: 'Shortlist universities update',
		type: 'Application',
		studentId: 12,
		studentName: 'Emily C.',
		studentCountry: 'UK',
		due: 'This Month',
		dueDate: '2026-01-22',
		action: 'Review',
	},
	{
		id: 14,
		task: 'Essay structure outline check',
		type: 'Essay',
		studentId: 13,
		studentName: 'Marcus J.',
		studentCountry: 'US',
		due: 'Jan 08',
		dueDate: '2026-01-08',
		action: 'Review',
	},
	{
		id: 15,
		task: 'Document set: transcripts + translations',
		type: 'Document',
		studentId: 14,
		studentName: 'Olivia B.',
		studentCountry: 'AU',
		due: 'This Month',
		dueDate: '2026-01-30',
		action: 'Verify',
	},
	{
		id: 16,
		task: 'Scholarship application review',
		type: 'Application',
		studentId: 15,
		studentName: 'Sarah C.',
		studentCountry: 'US',
		due: 'This Month',
		dueDate: '2026-01-27',
		action: 'Review',
	},
]
